<template>
  <div v-if="isReadyToDraw" class="mb-foot-2button">
    <MFITTHeader
      v-if="
        inputtedInfoOnBooking.isReservedChange ||
        inputtedInfoOnBooking.isPurchasedChange
      "
      header-title="変更内容確認"
    />
    <MFITTHeader
      v-else-if="inputtedInfoOnBooking.is_reservated"
      header-title="予約内容確認"
    />
    <MFITTHeader v-else-if="isUseCoupon" header-title="引き換え内容確認" />
    <MFITTHeader v-else header-title="購入内容確認" />

    <template
      v-if="
        !inputtedInfoOnBooking.isReservedChange &&
        !inputtedInfoOnBooking.isPurchasedChange &&
        !inputtedInfoOnBooking.is_reservated
      "
    >
      <div v-if="isUseCoupon" class="caution-note">
        <h1 class="caution-note-title">
          引き換え手続きはまだ完了していません。
        </h1>
        <p class="caution-note-text">内容をご確認のうえ、よろしければ</p>
        <p class="caution-note-text">「引き換え」を押してください。</p>
      </div>

      <div v-else class="caution-note">
        <h1 class="caution-note-title">購入手続きはまだ完了していません。</h1>
        <p class="caution-note-text">内容をご確認のうえ、よろしければ</p>
        <p class="caution-note-text">
          「上記の内容で決済に進む」を押してください。
        </p>
      </div>
    </template>

    <div class="content-block">
      <div class="block">
        <!-- 乗車日 -->
        <ViBoardingDate :boarding-date="vacancyInquiry.boarding_date" />

        <!-- 列車名 -->
        <ViTrainInfo
          :name="selectedTrainInfo.train.name"
          :cars-formation-name="selectedTrainInfo.cars_formation.name"
        />

        <!-- 区間 -->
        <ViStationSection
          :from="selectedTrainInfo.from_station.name"
          :to="selectedTrainInfo.to_station.name"
        />

        <!-- 時間 -->
        <ViDepartureAndArrival
          :departure="selectedTrainInfo.departure_at"
          :arrival="selectedTrainInfo.arrival_at"
        />

        <!-- 人数 -->
        <StorePassenger
          :adult="inputtedInfoOnBooking.adult_count"
          :child="inputtedInfoOnBooking.child_count"
          :is-saloon="inputtedInfoOnBooking.special_designation.id == 8"
        />

        <!-- 座席種類 -->
        <StoreSeatType
          :selected-seat-type="inputtedInfoOnBooking.seat_type.name"
        />

        <!-- 号車 -->
        <StoreCarNumber
          v-if="inputtedInfoOnBooking.method == '条件指定'"
          :selected-car-number="Number(inputtedInfoOnBooking.car_number)"
        />

        <!-- 条件 -->
        <StoreSpecialDesignation
          v-if="inputtedInfoOnBooking.method == '条件指定' && !isMultiDivision"
          :label="inputtedInfoOnBooking.special_designation.label"
        />

        <!-- 席が離れた場合は -->
        <StoreSeatDivision
          v-else-if="
            inputtedInfoOnBooking.method == '条件指定' && isMultiDivision
          "
          :label="inputtedInfoOnBooking.division.label"
        />

        <!-- 座席 シート指定を選んでいる場合-->
        <StoreSelectedSeats
          v-if="inputtedInfoOnBooking.method == 'シート指定'"
          :selected-seats="inputtedInfoOnBooking.selected_seats"
        />

        <!-- 購入済みチケットの変更/引換えの場合は、運賃/クレカ情報は表示しない -->
        <template
          v-if="
            !(
              inputtedInfoOnBooking.isPurchasedChange ||
              inputtedInfoOnBooking.is_reservated ||
              isUseCoupon
            )
          "
        >
          <!-- 運賃表示 -->
          <!-- サルーン以外は大人料金*大人人数+子供料金*子供人数 -->
          <!-- サルーンは大人料金*選択した席数 -->
          <StoreTicketPrice
            v-if="inputtedInfoOnBooking.special_designation.id != 8"
            :total-price="
              ticketPrice.limited_express_ticket_adult_price *
                inputtedInfoOnBooking.adult_count +
              ticketPrice.limited_express_ticket_child_price *
                inputtedInfoOnBooking.child_count
            "
          />
          <StoreTicketPrice
            v-else
            :total-price="
              ticketPrice.limited_express_ticket_adult_price *
              inputtedInfoOnBooking.selected_seats.length
            "
          />

          <!-- 購入を選んでいる場合はクレカ情報取得して表示する -->
          <!-- <StoreCardInfo v-if="!inputtedInfoOnBooking.is_reservated" :cardInfo="creditCard" /> -->
          <StoreSelectedPaymentMethod :payment-method="paymentMethod" />
        </template>
      </div>
      <div
        v-if="
          !inputtedInfoOnBooking.is_reservated &&
          !inputtedInfoOnBooking.isReservedChange &&
          !inputtedInfoOnBooking.isPurchasedChange &&
          !isExChange &&
          !isSubscription
        "
        class="bottom-note"
      >
        <p class="caution-note-bottom">
          ※必ず次に開く画面で決済を行ってください。
        </p>
        <p class="caution-note-bottom">
          決済が完了するまでブラウザの「戻る」ボタンを押さないでください。
        </p>
      </div>
      <div class="foot-button-block">
        <ItemButton
          v-if="isUseCoupon"
          action-type="btn-primary"
          :label="
            inputtedInfoOnBooking.isPurchasedChange ? '変更する' : '引き換え'
          "
          @clicked="onPressedBooking"
        />
        <ItemButton
          v-else-if="inputtedInfoOnBooking.is_reservated"
          action-type="btn-primary"
          :label="
            inputtedInfoOnBooking.isReservedChange ? '変更する' : '予約する'
          "
          @clicked="onPressedBooking"
        />
        <ItemButton
          v-else
          action-type="btn-primary"
          :label="
            inputtedInfoOnBooking.isPurchasedChange
              ? '変更する'
              : '上記の内容で決済に進む'
          "
          @clicked="onPressedBooking"
        />
        <ItemButton
          action-type="btn-cancel"
          label="戻る"
          @clicked="backToPreviousPage"
        />
      </div>
    </div>
  </div>

  <!-- 予約数が上限(50)に達している場合のエラーダイアログ -->
  <DialogOverResavationLimit ref="DialogOverResavationLimit" />

  <!-- 予約自動取り消し後、変更不可のエラーダイアログ -->
  <DialogCanNotChangeAfterCanceled ref="DialogCanNotChangeAfterCanceled" />

  <!-- 予約期限を超えて予約しようとした場合のエラーダイアログ -->
  <DialogCanNotReserveBecauseOverLimit
    ref="DialogCanNotReserveBecauseOverLimit"
  />

  <!-- 購入期限を超えて購入しようとした場合のエラーダイアログ -->
  <DialogCanNotPurchaseAfterDeparture
    ref="DialogCanNotPurchaseAfterDeparture"
  />

  <!-- 引き換え期限を超えて引き換えしようとした場合のエラーダイアログ -->
  <DialogCanNotExchangeAfterDeparture
    ref="DialogCanNotExchangeAfterDeparture"
  />

  <!-- 変更期限を超えて変更しようとした場合のエラーダイアログ -->
  <DialogCanNotChangeAfterDeparture ref="DialogCanNotChangeAfterDeparture" />

  <!-- 購入後の予約変更時(2回目)のエラーダイアログ -->
  <DialogCanNotChangePurchasedTicket ref="DialogCanNotChangePurchasedTicket" />

  <!-- 同日、同一駅を含む特急券を所持している場合のエラーダイアログ -->
  <DialogHasSameTicket ref="DialogHasSameTicket" />

  <!-- ローディングダイアログ -->
  <DialogLoading ref="DialogLoading" :timeout-seconds="21000" />

  <!-- 電波状況が悪い場合のエラーダイアログ -->
  <DialogBadReception ref="DialogBadReception" />

  <DialogDuringMaintenance ref="DialogDuringMaintenance" />

  <DialogUnexpectedError ref="DialogUnexpectedError" />

  <DialogTemporaryBlocked ref="DialogTemporaryBlocked" />

  <DialogPurchaseWarning ref="DialogPurchaseWarning" />
  <DialogDenyPurchaseWarning
    ref="DialogDenyPurchaseWarning"
    :close-click="goToIndexPage"
  />
  <DialogGeneralPuchaseWarning ref="DialogGeneralPuchaseWarning" />
</template>

<script>
import { computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import API from "@/API";
import storeJS from "@/store";

import mfittService from "@/services/MFITT";
import nativeHandlerService from "@/services/nativeHandler";
import { CAR_SPECIAL_DESIGNATIONS_MAP } from "@/lib/constants";

window.jcExpressTicketReceivePayment = function (url) {
  console.log("TemplateMfittBookingConfirmation");
  const params = new window.URL(url).searchParams;
  const processId = params.get("process_id");
  const result = params.get("result");

  if (
    !url.includes("sbps_express_purchase") ||
    !processId ||
    !["cancel", "success", "error"].includes(result)
  ) {
    return;
  }
  storeJS.commit("MFITT/setPaymentResult", {
    processId,
    result,
  });
};

export default {
  name: "TemplateMfittBookingConfirmation",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    store.commit("MFITT/setPaymentResult", null);

    store.commit("MFITT/setShowDenyPurchaseWarning", null);
    const selectedCoupon = store.getters["MFITT/selectedCoupon"];
    const isUseCoupon = selectedCoupon != null;
    const isSubscription = selectedCoupon?.type == "subscription";
    const isExChange = selectedCoupon?.type == "exchange";

    const DialogOverResavationLimit = ref(null);
    const DialogCanNotChangeAfterCanceled = ref(null);
    const DialogCanNotReserveBecauseOverLimit = ref(null);
    const DialogCanNotPurchaseAfterDeparture = ref(null);
    const DialogCanNotExchangeAfterDeparture = ref(null);
    const DialogCanNotChangeAfterDeparture = ref(null);
    const DialogCanNotChangePurchasedTicket = ref(null);
    const DialogHasSameTicket = ref(null);
    const DialogLoading = ref(null);
    const DialogBadReception = ref(null);
    const DialogUnexpectedError = ref(null);
    const DialogDuringMaintenance = ref(null);
    const DialogTemporaryBlocked = ref(null);
    const DialogPurchaseWarning = ref(null);

    const DialogDenyPurchaseWarning = ref(null);
    const DialogGeneralPuchaseWarning = ref(null);
    const isReadyToDraw = ref(false);

    const isDisabledBooking = ref(false);

    // 購入を選んでいる場合は表示
    const creditCard = computed(() => store.getters["common/CreditCard"]);

    // 選ばれた列車情報
    const selectedTrainInfo = computed(
      () => store.getters["MFITT/vacancyInquiry"].train_info[route.params.id]
    );

    // 列車の空席情報
    const vacancyInquiry = computed(
      () => store.getters["MFITT/vacancyInquiry"]
    );

    // フロントで管理してる情報
    const inputtedInfoOnBooking = store.getters["MFITT/inputtedInfoOnBooking"];

    // 運賃Object
    const ticketPrice = computed(() => store.getters["MFITT/ticketPrice"]);

    // 人数が1以上かのフラグ
    const isMultiDivision = computed(
      () =>
        inputtedInfoOnBooking.adult_count + inputtedInfoOnBooking.child_count >
        1
    );

    const selectedPaymentMethod = computed(
      () => store.getters["MFITT/selectedPaymentMethod"]
    );

    const paymentMethods = computed(
      () => store.getters["MFITT/paymentMethods"]
    );

    const paymentMethod = computed(
      () =>
        paymentMethods.value?.find(
          (method) => method.id === selectedPaymentMethod.value
        )?.name
    );

    const paymentResult = computed(() => store.getters["MFITT/paymentResult"]);

    const showDenyPurchaseWarning = computed(
      () => store.getters["MFITT/showDenyPurchaseWarning"]
    );
    const onPressedBooking = async () => {
      // ボタンの連続押下を防ぐため、trueの場合は処理しない
      // if (isDisabledBooking.value) {
      //   return;
      // } else {
      //   // 処理前にtrueに
      //   isDisabledBooking.value = true;
      // }

      // ローディングダイアログ
      // DialogLoading.value.openDialog();

      // 予約変更から遷移してきた場合は、変更処理
      if (
        inputtedInfoOnBooking.isReservedChange ||
        inputtedInfoOnBooking.isPurchasedChange
      ) {
        await changeMyTicket();
        // 予約/購入処理(変更ではない)
      } else {
        await booking();
      }
    };

    // 予約/購入
    const booking = async () => {
      try {
        //prevent purchase multiple times
        if (showDenyPurchaseWarning.value) {
          DialogDenyPurchaseWarning.value.openDialog();
          return;
        }
        // 予約・購入API
        // await API.postBookingOrPurchase(makeBookingApiParams());
        // goToBookingResultPage("booking");
        if (
          inputtedInfoOnBooking.is_reservated ||
          isSubscription ||
          isExChange
        ) {
          if (isUseCoupon) {
            DialogLoading.value.openDialog();
          }
          const response = await API.postBookingOrPurchase(
            makeBookingApiParams()
          );

          const ticketId = response.id;
          goToBookingResultPage("booking", ticketId);
        } else {
          openPurchaseWarningDialog();

          const params = makeBookingSpecifyUrlApiParams();

          console.log("BookingApiParams", params);

          let response = await API.postBookingOrPurchase(params);
          if (response && response.url != null && response.url != "") {
            nativeHandlerService.ncOpenExternalUrl(response.url);
          }
        }
      } catch (e) {
        // ボタンのdisabledを戻す
        isDisabledBooking.value = false;
        if (
          !(inputtedInfoOnBooking.is_reservated || isSubscription || isExChange)
        ) {
          generalPurchaseErrorHandler(e);
        } else {
          errorHandler(e);
        }
      }
    };

    // 予約/購入内容の変更
    const changeMyTicket = async () => {
      // ボタンの連続押下を防ぐため、trueの場合は処理しない
      if (isDisabledBooking.value) {
        return;
      } else {
        // 処理前にtrueに
        isDisabledBooking.value = true;
      }

      // ローディングダイアログ
      DialogLoading.value.openDialog();
      try {
        const response = await API.postChangeMyTicket(makeChangeApiParams());
        const ticketId = response.id;
        goToBookingResultPage("change", ticketId);
      } catch (e) {
        // ボタンのdisabledを戻す
        isDisabledBooking.value = false;

        // 電波がない場合、e.response.data.messageが存在しない
        // loadingを表示し続け、そちらでタイムアウトさせる
        if (e.response.data.message) {
          errorHandler(e);
        } else {
          nativeHandlerService.ncSendMfittError(
            "TemplateMfittBookingConfirmation changeMyTicket()"
          );
        }
      }
    };

    // 予約/購入/変更APIのエラーハンドリング
    const errorHandler = (e) => {
      DialogLoading.value.closeDialog();
      console.log("Error in MFITT Booking", e);

      // 予約上限数に達している場合
      if (e.response.data.message === "リクエストが不正です(100050)") {
        DialogOverResavationLimit.value.openDialog();
        // 予約期限(発車45分前)を過ぎている場合
      } else if (
        e.response.data.message ===
        "departure_at予約は発車時刻の45分前まで可能です"
      ) {
        DialogCanNotReserveBecauseOverLimit.value.openDialog();
        // 購入期限(発車時刻)を過ぎている場合
      } else if (e.response.data.message === "リクエストが不正です(100031)") {
        DialogCanNotPurchaseAfterDeparture.value.openDialog();
        // 引き換え期限(発車時刻)を過ぎている場合
      } else if (
        e.response.data.message ===
        "指定乗車日は既に過去又は指定列車は既に発車済みです"
      ) {
        if (inputtedInfoOnBooking.isPurchasedChange) {
          DialogCanNotChangeAfterDeparture.value.openDialog();
        } else {
          DialogCanNotExchangeAfterDeparture.value.openDialog();
        }
        // 変更期限(変更前の発車時刻)を過ぎている場合
      } else if (
        e.response.data.message ===
        "original_train_departed指定の特急券の列車は既に発車済みです"
      ) {
        DialogCanNotChangeAfterDeparture.value.openDialog();
      }
      // 指定した座席/条件に合う座席がない場合
      else if (e.response.data.message === "座席を確保できませんでした") {
        goToBookingErrorPage();
        // 同日、同一駅を含む特急券を所持している場合
      } else if (
        e.response.data.message ===
        "same_limited_express_ticket_valid同日、同一駅を含む特急券を予約済みです"
      ) {
        DialogHasSameTicket.value.openDialog();
        // 予約が自動取り消し済の場合
      } else if (
        e.response.data.message ===
        "ticketing_status指定された特急券は予約取消済みです"
      ) {
        DialogCanNotChangeAfterCanceled.value.openDialog();
        // 2回目以降の日付変更の場合
      } else if (
        e.response.data.message ===
        "boarding_date異なる乗車日への変更は1回のみです"
      ) {
        DialogCanNotChangePurchasedTicket.value.openDialog();
      } else if (e.response.data.message === "回線が込み合っています") {
        DialogBadReception.value.openDialog();
        // MWのメンテナンス中
      } else if (e.response.status == 503) {
        DialogDuringMaintenance.value.openDialog(e.response.data);
        // 発券重複
      } else if (e.response.data.error == "temporary_blocked_ticketing") {
        DialogTemporaryBlocked.value.openDialog();
        // その他のエラー
      } else {
        // nativeにエラー内容送信
        nativeHandlerService.ncSendMfittError(e.response.data.message);
        DialogUnexpectedError.value.openDialog();
      }
    };

    // Handle General Purchase Error
    const generalPurchaseErrorHandler = (e) => {
      closePurchaseWarningDialogByTrigger();
      console.log("General Purchase Error in MFITT Booking", e);
      DialogGeneralPuchaseWarning.value.openDialog();
    };

    const goToBookingResultPage = (method, ticketId) => {
      router.push({
        name: "MfittBookingResult",
        params: { id: route.params.id },
        query: {
          method: method,
          coupon_id: route.query.coupon_id,
          ticket_id: ticketId,
        }, // 予約/購入:booking, 変更:change
      });
    };

    const goToBookingErrorPage = () => {
      let method;
      if (inputtedInfoOnBooking.method == "シート指定") {
        method = "seat";
      } else if (inputtedInfoOnBooking.method == "条件指定") {
        method = "conditions";
      }
      router.push({
        name: "MfittBookingError",
        params: { id: route.params.id },
        query: { specifyMethod: method, coupon_id: route.query.coupon_id },
      });
    };

    const backToPreviousPage = () => {
      router.go(-1);
    };

    // 予約/購入APIに必要なパラメータ制作
    const makeBookingApiParams = () => {
      let params = {
        boarding_date: mfittService.convertDateFormatForApi(
          vacancyInquiry.value.boarding_date
        ),
        train_number: selectedTrainInfo.value.train.train_number,
        from_station_id: selectedTrainInfo.value.from_station.id,
        to_station_id: selectedTrainInfo.value.to_station.id,
        adult_count: inputtedInfoOnBooking.adult_count,
        child_count: inputtedInfoOnBooking.child_count,
        special_designation: inputtedInfoOnBooking.special_designation.id,
        is_reservated: inputtedInfoOnBooking.is_reservated,
        description: "EMot App",
        // 意図しない発券の調査のため、ランダムな値を付与
        debug_code: Math.random().toString(32).substring(2),
        authorization_method_id: selectedPaymentMethod.value,
      };

      // 条件指定で号車選択を指定しない以外を選択の場合必須項目を追加
      if (inputtedInfoOnBooking.car_id != 0) {
        params["car_id"] = inputtedInfoOnBooking.car_id;
      }

      // サルーンの場合必須項目を追加
      if (inputtedInfoOnBooking.special_designation.id == 8) {
        params["saloon_count"] = inputtedInfoOnBooking.selected_seats.length;
      }

      // シートマップで選んだ席をリクエスト用に配列に整理し直して、パラメータに追加
      if (inputtedInfoOnBooking.method == "シート指定") {
        let seats = [];
        inputtedInfoOnBooking.selected_seats.forEach((seat) => {
          seats.push({ number: seat.seat.seat_number });
        });
        params["seats"] = seats;
        params["division"] = 1;

        // サルーン以外(一般席・展望席)の場合special_designationを7で上書き
        if (inputtedInfoOnBooking.special_designation.id != 8) {
          if (
            !CAR_SPECIAL_DESIGNATIONS_MAP.hasOwnProperty(
              inputtedInfoOnBooking.special_designation.id
            )
          ) {
            params["special_designation"] = 7;
          }
        }
      } else if (
        inputtedInfoOnBooking.method == "条件指定" &&
        isMultiDivision.value
      ) {
        // 複数人なら席が離れた場合は、の必須項目追加
        params["division"] = inputtedInfoOnBooking.division.id;
      }

      // 引換券使用の場合は、idを追加
      if (isUseCoupon) {
        params["coupon_id"] = selectedCoupon.id;
      }

      return params;
    };

    const makeBookingSpecifyUrlApiParams = () => {
      let params = makeBookingApiParams();
      params["return_url"] = process.env.VUE_APP_SBPS_EXPRESS_PURCHASE_SUCCESS;
      params["error_url"] = process.env.VUE_APP_SBPS_EXPRESS_PURCHASE_ERROR;
      params["cancel_url"] = process.env.VUE_APP_SBPS_EXPRESS_PURCHASE_CANCEL;
      return params;
    };

    // 予約/購入チケット変更APIに必要なパラメータ制作
    const makeChangeApiParams = () => {
      let params = {
        resource_id: inputtedInfoOnBooking.ticketId,
        boarding_date: mfittService.convertDateFormatForApi(
          vacancyInquiry.value.boarding_date
        ),
        train_number: selectedTrainInfo.value.train.train_number,
        special_designation: inputtedInfoOnBooking.special_designation.id,
      };

      // 条件指定で号車選択を指定しない以外を選択の場合必須項目を追加
      if (inputtedInfoOnBooking.car_id != 0) {
        params["car_id"] = inputtedInfoOnBooking.car_id;
      }

      // シートマップで選んだ席をリクエスト用に配列に整理し直して、パラメータに追加
      if (inputtedInfoOnBooking.method == "シート指定") {
        let seats = [];
        inputtedInfoOnBooking.selected_seats.forEach((seat) => {
          seats.push({ number: seat.seat.seat_number });
        });
        params["seats"] = seats;
        params["division"] = 1;

        // サルーン以外(一般席・展望席)の場合special_designationを7で上書き
        if (inputtedInfoOnBooking.special_designation.id != 8) {
          if (
            !CAR_SPECIAL_DESIGNATIONS_MAP.hasOwnProperty(
              inputtedInfoOnBooking.special_designation.id
            )
          ) {
            params["special_designation"] = 7;
          }
        }
      } else if (
        inputtedInfoOnBooking.method == "条件指定" &&
        isMultiDivision.value
      ) {
        // 複数人なら席が離れた場合は、の必須項目追加
        params["division"] = inputtedInfoOnBooking.division.id;
      }

      return params;
    };

    const openPurchaseWarningDialog = () => {
      console.log("openPurchaseWarningDialog::");
      try {
        DialogPurchaseWarning.value.openDialog();

        //make the flag is true to deny second tab to purchase button
        store.commit("MFITT/setShowDenyPurchaseWarning", true);
      } catch {}
    };
    const closePurchaseWarningDialogByTrigger = () => {
      //trigger when get sbps_url error happen or sbps cancel
      console.log("closePurchaseWarningDialog::");
      try {
        DialogPurchaseWarning.value.closeDialog();

        //make the flag is null to aloow user can click purchase button again
        store.commit("MFITT/setShowDenyPurchaseWarning", null);
      } catch {}
    };

    const goToIndexPage = () => {
      nativeHandlerService.returnNativeAppMfittIndexPage();
    };

    watchEffect(() => {
      if (ticketPrice.value != null) {
        isReadyToDraw.value = true;
      }
    });

    watchEffect(() => {
      console.log(
        "watchEffect::paymentResult::" + JSON.stringify(paymentResult.value)
      );
      if (paymentResult.value != null) {
        if (paymentResult.value.result == "cancel") {
          closePurchaseWarningDialogByTrigger();
          return;
        } else {
          //return_url or error_url -> move to processing page
          router.push({
            name: "MfittBookingProcessing",
            params: { id: route.params.id },
            query: { coupon_id: route.query.coupon_id },
          });
        }
      }
    });

    return {
      isReadyToDraw,
      isUseCoupon,
      isSubscription,
      isExChange,
      selectedTrainInfo,
      onPressedBooking,
      inputtedInfoOnBooking,
      vacancyInquiry,
      creditCard,
      ticketPrice,
      selectedPaymentMethod,
      paymentMethod,
      isMultiDivision,
      backToPreviousPage,
      changeMyTicket,
      goToIndexPage,
      DialogOverResavationLimit,
      DialogCanNotChangeAfterCanceled,
      DialogCanNotReserveBecauseOverLimit,
      DialogCanNotPurchaseAfterDeparture,
      DialogCanNotExchangeAfterDeparture,
      DialogCanNotChangeAfterDeparture,
      DialogCanNotChangePurchasedTicket,
      DialogHasSameTicket,
      DialogLoading,
      DialogBadReception,
      DialogUnexpectedError,
      DialogDuringMaintenance,
      DialogTemporaryBlocked,
      DialogPurchaseWarning,
      DialogDenyPurchaseWarning,
      DialogGeneralPuchaseWarning,
    };
  },
};
</script>

<style scoped>
.mb-foot-2button {
  margin-bottom: 160px;
}

.content-block {
  width: 100%;
  padding: 0 0 16px;
}

.content-block .block {
  display: table;
  font-size: 13px;
}

.foot-button-block {
  position: fixed;
  z-index: 99;
  left: 0;
  width: 90%;
  bottom: 0;
  background-color: #ffffff;
  padding: 15px 15px 20px 15px;
}

.caution-note-title {
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #ff3333;
}

.caution-note-text {
  font-weight: bold;
  text-align: center;
  line-height: 18px;
  font-size: 16px;
}

.caution-note,
.bottom-note {
  padding: 10px;
  margin-bottom: 15px;
}

.bottom-note {
  margin-top: 30px;
}
.caution-note-bottom {
  font-size: 16px;
  font-weight: bold;
  text-align: justify;
  color: #ff3333;
}
</style>
